import { useState, useEffect } from 'react';
import '../styles/RingerPopup.css';

const RingerPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if user is on mobile
    const checkMobile = () => {
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      setIsMobile(isMobileDevice);
      if (isMobileDevice) {
        setIsVisible(true);
        // Hide popup after 5 seconds
        setTimeout(() => setIsVisible(false), 5000);
      }
    };

    checkMobile();
  }, []);

  if (!isMobile || !isVisible) return null;

  return (
    <div className="ringer-popup">
      <div className="ringer-popup-content">
        <div className="ringer-icon">
          🔔
        </div>
        <p>Hi! This is a sound-based experience – please turn on your phone ringer to hear the music :)</p>
      </div>
    </div>
  );
};

export default RingerPopup; 